import {
    ArrayModel,
    CompositeModel,
    ConfigConstants,
    CustomInjector,
    MaterialCheckModel,
    ModelOptionsLoaderService,
    NumberModel,
    TextModel,
    ConfigInstanceToken,
} from '@evorait/pace-core';

export default class MaterialAvailabilityModel extends CompositeModel {
    public materialNumber: TextModel;
    public quantity: NumberModel;
    public materials: TextModel;
    public partSet: ArrayModel<MaterialCheckModel>;
    public frontId: TextModel;
    public salesOrg: TextModel;
    public plant: TextModel;
    public longText: ArrayModel<TextModel>;
    public constructor() {
        super('MaterialAvailabilityModel');
        const injector = CustomInjector.getInjector();
        const modelOptionsLoader = injector.get(ModelOptionsLoaderService);
        const configService = injector.get(ConfigInstanceToken);

        this.materialNumber = new TextModel('MaterialNumber');
        modelOptionsLoader.load(this.materialNumber, 'MaterialAvailability', 'MaterialNumber');

        this.materialNumber.options = {
            ...this.materialNumber.options,
            applicationIdentifier: ConfigConstants.ApplicationIdentifier.ProductIdentifier,
        };

        this.quantity = new NumberModel('Quantity', 1);

        this.partSet = <ArrayModel<MaterialCheckModel>>this.set(new ArrayModel<MaterialCheckModel>('PartSet', []));

        this.frontId = <TextModel>this.set(new TextModel('FrontId', configService.getUserFrontId()));

        this.longText = <ArrayModel<TextModel>>this.set(new ArrayModel('LtextSet', []));
    }

    /**
     * This function adds the current material and its quantity to the PartSet model.
     */
    public addMaterialToPartSet(): void {
        const currentMaterial = new MaterialCheckModel(this.materialNumber.value, this.quantity.value ?? 0, '');
        this.partSet.addModel(currentMaterial);
        if (this.longText !== undefined) {
            this.longText.addModel(new TextModel('Material', this.materialNumber.value));
        }
        // reset input field
        this.materialNumber = new TextModel('MaterialNumber', '', this.materialNumber.options);
    }

    public deleteMaterialFromPartSet(index: number): void {
        this.partSet.removeModel(index);
        if (this.longText !== undefined) {
            this.longText.removeModel(index);
        }
    }
}
